module.exports = __webpack_public_path__ + "static/police-mimms-253afc526ee4225775ca455a8b3ae100.gif";